// extracted by mini-css-extract-plugin
export default {"carCardDetailsSwiper":"CarDetails_carCardDetailsSwiper__+FGtQ"};